import clsx from "clsx";
import styles from "./index2.module.scss";
import { useCommonStore } from "@/stores";
import { useEffect, useRef } from "react";
import { loadScript } from "@/utils";

type FtLoadingProps = {
  title: string;
  desc?: string;
  className?: string;
};

const FtLoading2 = (props: FtLoadingProps) => {
  const { title, className } = props;

  const loadingEleRef = useRef<HTMLDivElement>(null);

  const isMobile = useCommonStore((state) => state.isMobile);
  const instanceRef = useRef<any>(null);

  useEffect(() => {
    (async () => {
      if (!window.lottie) {
        await loadScript(
          "https://cdn.jsdelivr.net/npm/lottie-web@5.12.2/build/player/lottie.min.js"
        );
      }
      instanceRef.current = window.lottie.loadAnimation({
        container: loadingEleRef.current!,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: process.env.PUBLIC_URL + "/lotties/loading/foto-web-loading.json",
      });
    })();

    return () => {
      instanceRef.current?.destroy?.();
    };
  }, []);

  return (
    <div className={clsx(styles["root"], className)}>
      <div ref={loadingEleRef} className={styles["loading"]}></div>

      <p className={clsx(styles["text"])}>{title}</p>
      {/*{props.desc && <p className={clsx(styles["desc"])}>{props.desc}</p>}*/}
    </div>
  );
};

export default FtLoading2;
